import type { DetailedHTMLProps, FormHTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement> {
    noPreventDefaultAfterSubmit?: boolean
}
export const Form = ({ noPreventDefaultAfterSubmit, onSubmit, ...props }: Props) => {
    const handleSubmit: Props['onSubmit'] = (event) => {
        !noPreventDefaultAfterSubmit && event.preventDefault()
        onSubmit?.(event)
    }
    return <form onSubmit={handleSubmit} role="form" {...props} />
}
